import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = not auth
  const [theme, setTheme] = useState(() => localStorage.getItem("teca_theme") || "light");
  const [territoire, setTerritoire] = useState(() => localStorage.getItem("teca_territoire") || "Guadeloupe");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("teca_theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("teca_territoire", territoire);
  }, [territoire]);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
  };

  return (
    <AppCtx.Provider value={{ user, setUser, refreshUser, logout, theme, setTheme, territoire, setTerritoire }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
